import React, { useEffect } from "react";

import Main from '../components/Trading/Main'
import Switcher from "../components/Trading/Switcher";

function Trading () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="relative overflow-hidden mt-[60px]">
            <Main/>
            <Switcher/>
        </div>
    );
}

export default Trading;